import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import apiClient from '../services/apiClient';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    const type = searchParams.get('type') || 'registration';

    if (!token) {
      setStatus('error');
      setMessage('No verification token provided.');
      return;
    }

    apiClient.post('/api/auth/verify-email', { token, type })
      .then(data => {
        setStatus('success');
        setMessage(data.message || 'Email verified successfully!');
      })
      .catch(err => {
        setStatus('error');
        setMessage(err.data?.message || err.message || 'Verification failed.');
      });
  }, [searchParams]);

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        {status === 'verifying' && (
          <>
            <h1>Verifying Email...</h1>
            <p className="subtitle">Please wait while we verify your email address.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <h1>Email Verified</h1>
            <div className="success-message">{message}</div>
            <Link to="/login" className="btn btn-primary" style={{ display: 'inline-block', marginTop: '1rem' }}>
              Sign In
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <h1>Verification Failed</h1>
            <div className="error-message">{message}</div>
            <Link to="/login" className="btn btn-secondary" style={{ display: 'inline-block', marginTop: '1rem' }}>
              Back to Sign In
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
